__turbopack_context__.v({
  "className": "fraunces_935b0734-module__XlZDsa__className",
  "variable": "fraunces_935b0734-module__XlZDsa__variable",
});
